import { Breadcrumb } from "components";
import { useIntl } from "react-intl";

import { useNavigate, useParams } from "react-router-dom";

import { DoctorInfo } from "./DoctorInfo";
import { DoctorRenderList } from "./DoctorRenderList";

import { useDoctorsModalContent } from "./hooks";

import "./DoctorsModalContent.scss";
import { useContext, useEffect } from "react";
import { AuthContext, AuthorizationStage } from "providers/AuthProvider/context/AuthContext";

interface DoctorsModalContentProps {
  setCurrentDoctorId: (value: number | string) => void;
}

export const DoctorsModalContent = ({
  setCurrentDoctorId,
}: DoctorsModalContentProps) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authorizationStage } = useContext(AuthContext);
  const { doctorContent } = useDoctorsModalContent({ id: Number(id) });
  const { formatMessage } = useIntl();
  
  useEffect(() => {
    if (id) setCurrentDoctorId(id);
  }, [id, setCurrentDoctorId]);

  return (
    <div className="doctors-modal-content">
      <Breadcrumb
        links={[
          { label: formatMessage({
                id: "main.breadcrumb",
                defaultMessage: "_Home_",
              }), value: "/" },
          { label: formatMessage({
            id: "doctors.breadcrumb",
            defaultMessage: "_Doctors_",
          }), value: `/doctors/1` },
          { label: doctorContent?.name, value: `/doctors/1` },
        ]}
      />
      <DoctorInfo
        title={doctorContent?.name}
        subtitle={doctorContent?.specialties
    ?.map((speciality: any) => speciality?.title) // Extract the titles
    ?.join(', ')
        }
        branches={doctorContent?.branches}
        languages={doctorContent?.languages}
        image={doctorContent?.photo}
        onClick={() => authorizationStage === AuthorizationStage.AUTHORIZED ? navigate('/pr-visit-doctor') : navigate('/login')}
        gender={doctorContent?.gender}
      />
      {doctorContent?.additional?.map((item: any) => (
        <DoctorRenderList
          key={item?.key}
          title={item?.attributes?.title}
          list={item?.attributes?.sections}
        />
      ))}
    </div>
  );
};
